/**
 * Hosts that serve the full NoPanel control-plane SPA (not status-only custom domains).
 * Custom domains map 1:1 to a public status page via Host → by-host API.
 */
const PRIMARY_HOSTS = new Set([
  'ops.nopanel.dev',
  'ops.zoom.ci',
  'localhost',
  '127.0.0.1',
  '::1',
]);

export function isPrimaryControlPlaneHost(hostname?: string): boolean {
  const h = (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase();
  if (!h) return true;
  if (PRIMARY_HOSTS.has(h)) return true;
  // Vite / local LAN
  if (h.endsWith('.local') || h.endsWith('.localhost')) return true;
  // Private IPs used for dev
  if (/^10\./.test(h) || /^192\.168\./.test(h) || /^172\.(1[6-9]|2\d|3[0-1])\./.test(h)) return true;
  return false;
}

/** True when this browser origin should only show a public status page. */
export function isCustomStatusHost(hostname?: string): boolean {
  return !isPrimaryControlPlaneHost(hostname);
}
